import { motion, useMotionValue, useTransform, animate, useInView } from "framer-motion";
import { useEffect, useRef } from "react";
import { STATS } from "../../constants/siteData";

const Counter = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  const numeric = parseInt(value.replace(/\D/g, ""), 10) || 0;
  const suffix = value.replace(/[0-9]/g, "");
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) => Math.round(v));

  useEffect(() => {
    if (inView) {
      const controls = animate(mv, numeric, { duration: 1.6, ease: [0.22, 1, 0.36, 1] });
      return controls.stop;
    }
  }, [inView, mv, numeric]);

  return (
    <span ref={ref} className="font-display text-6xl md:text-7xl lg:text-8xl text-cream tracking-tighter">
      <motion.span>{rounded}</motion.span>
      <span className="text-coral">{suffix}</span>
    </span>
  );
};

export const Stats = () => {
  return (
    <section
      className="relative bg-[#061223] py-20 md:py-28 border-y hairline"
      data-testid="stats-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="flex flex-col items-start"
              data-testid={`stat-${i}`}
            >
              <Counter value={s.value} />
              <div className="mt-3 h-[1px] w-10 bg-coral" />
              <p className="mt-3 text-xs md:text-sm tracking-[0.2em] uppercase text-white/60">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
